<template>
  <div class="wrap">
    <router-view :key="key"></router-view>
    <tab-bar :type="type"></tab-bar>
  </div>
</template>
<script>
import tabBar from './common/tabBar';
import { getMain, getMenu, getShopinfos } from '@/api/index';
import { accountView } from '@/api/capital';
export default {
  name: 'index',
  components: {
    tabBar,
  },
  data() {
    return {
      type: 1,
    };
  },
  watch: {
    '$route.name': {
      handler(value) {
        switch (value) {
          case 'index':
            this.type = 1;
            break;
          case 'other':
            this.type = 2;
            break;
          case 'personal':
            this.type = 3;
            break;
          default:
            this.type = 1;
            break;
        }
      },
      immediate: true,
    },
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  created() {
    getMain()
      .then(res => {
        this.$store.commit('setUserinfos', res.data);
        if (res.data.hasAdapay) {
          this.$store.commit('setHasOpenPay', true);
        }
        return getMenu();
      })
      .then(res => {
        return getShopinfos();
      })
      .then(res => {
        let source = res.data.source || null;
        this.$store.commit('setSource', source);
      });
  },
};
</script>
<style lang="less" scoped>
.wrap {
  position: relative;
  min-height: 100vh;
  // padding: 0 12px;
}
</style>
